import React, {Component} from 'react'
import PropTypes from 'prop-types'
import humanizeTime from '../../../../../helpers/time/humanizeTime'
import LazyLoad from 'react-lazyload'

class ItemCreated extends Component {
    render() {
        const {createdAt, order} = this.props
        const textTime = createdAt ? humanizeTime(createdAt) : '-'

        const {approved_at} = order

        return (
            <td className='ItemCreated'>
                <LazyLoad>

                    {textTime}

                    {
                        !!approved_at && (
                            <div className="ApprovedAt">
                                <hr/>
                                <div><strong>Approved at:</strong></div>
                                <div>{humanizeTime(approved_at)}</div>
                            </div>
                        )
                    }
                </LazyLoad>
            </td>
        )
    }
}

ItemCreated.defaultProps = {
    createdAt: '',
}

ItemCreated.propTypes = {
    order: PropTypes.object.isRequired,
    createdAt: PropTypes.string.isRequired,
}

export default ItemCreated
